import CzechReferenceDataSources from './CzechReferenceDataSources';

export enum Resolution {
	accept = 'accept',
	acceptNoRulesForDataSource = 'accept-no-rules-for-data-source',
	acceptWithWarning = 'accept-with-warning',
	acceptBeforeValidity = 'accept-before-validity',
	cannotInterpretRules = 'cannot-interpret-rules',
	reject = 'reject',
	rejectNoPrices = 'reject-no-prices',
	rejectNotAReferenceDataSource = 'reject-not-a-reference-data-source',
	rejectRemoved = 'reject-removed',
	rejectAfterValidity = 'reject-after-validity',
}

export default class ProductCompliance {
	resolution: Resolution;

	ruleDescription: string | null;

	decisionComment: string | null;

	czechReferenceDataSources: CzechReferenceDataSources;

	constructor(
		resolution: Resolution,
		ruleDescription: string | null,
		decisionComment: string | null,
		czechReferenceDataSources: CzechReferenceDataSources
	) {
		this.resolution = resolution;
		this.ruleDescription = ruleDescription;
		this.decisionComment = decisionComment;
		this.czechReferenceDataSources = czechReferenceDataSources;
	}

	get isAccept(): boolean {
		return this.resolution === Resolution.accept;
	}

	get isAcceptNoRulesForDataSource(): boolean {
		return this.resolution === Resolution.acceptNoRulesForDataSource;
	}

	get isAcceptWithWarning(): boolean {
		return this.resolution === Resolution.acceptWithWarning;
	}

	get isAcceptBeforeValidity(): boolean {
		return this.resolution === Resolution.acceptBeforeValidity;
	}

	get isCannotInterpretRules(): boolean {
		return this.resolution === Resolution.cannotInterpretRules;
	}

	get isReject(): boolean {
		return this.resolution === Resolution.reject;
	}

	get isRejectNoPrices(): boolean {
		return this.resolution === Resolution.rejectNoPrices;
	}

	get isRejectNotAReferenceDataSource(): boolean {
		return this.resolution === Resolution.rejectNotAReferenceDataSource;
	}

	get isRejectRemoved(): boolean {
		return this.resolution === Resolution.rejectRemoved;
	}

	get isRejectAfterValidity(): boolean {
		return this.resolution === Resolution.rejectAfterValidity;
	}

	resolveRuleDescription(): string | null {
		if (this.isAcceptBeforeValidity) {
			return 'Validita produktu ještě nezačala. Zkontrolujte prosím detaily produktu.';
		}
		if (this.isRejectAfterValidity) {
			return 'Validita produktu skončila a produkt nemusí být vhodný pro cenové referencování. Zkontrolujte prosím detail produktu.';
		}
		if (this.ruleDescription !== null) {
			return this.ruleDescription;
		}
		if (this.isCannotInterpretRules) {
			return (
				'Price Monitor není schopen určit, zda je produkt v souladu s českými referenčními zdroji. ' +
				'Ujistěte se prosím, zda jej lze použít pro Vaše účely.'
			);
		}
		if (this.isRejectNotAReferenceDataSource) {
			return 'Zdroj tohoto produktu není referenční pro SÚKL a nemusí být vhodný k referencování.';
		}
		if (this.isRejectNoPrices) {
			return 'Produkt ve zdroji neobsahuje ceny potřebné k referencování.';
		}
		if (this.isRejectRemoved) {
			return 'Produkt byl odstraněn ze zdroje.';
		}
		return this.ruleDescription;
	}
}
